module.exports = __webpack_public_path__ + "static/media/month.c3ea56a5.svg";